export default "__VITE_ASSET__c8769e3a__"